const indexItems = [
  { id: 1, title: '热门日漫', icon: 'ri-sun-line', desc: '最新最热的日本动漫', count: '5800+ 部', color: 'accent' },
  { id: 2, title: '精品国漫', icon: 'ri-china-railway-line', desc: '优质国产动漫合集', count: '3200+ 部', color: 'primary' },
  { id: 3, title: '剧场版', icon: 'ri-film-line', desc: '动漫电影大银幕体验', count: '1200+ 部', color: 'accent' },
  { id: 4, title: '热血番', icon: 'ri-fire-line', desc: '燃到爆的热血战斗', count: '2100+ 部', color: 'primary' },
  { id: 5, title: '恋爱番', icon: 'ri-heart-line', desc: '甜蜜浪漫的恋爱物语', count: '1800+ 部', color: 'accent' },
  { id: 6, title: '异世界', icon: 'ri-earth-line', desc: '穿越异世界的奇幻冒险', count: '1600+ 部', color: 'primary' },
  { id: 7, title: '搞笑日常', icon: 'ri-emotion-laugh-line', desc: '轻松愉快的日常喜剧', count: '2400+ 部', color: 'accent' },
  { id: 8, title: '悬疑推理', icon: 'ri-search-eye-line', desc: '烧脑刺激的推理故事', count: '900+ 部', color: 'primary' },
];

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            动漫分类索引
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            按类型快速找到你想看的动漫，日漫国漫一应俱全
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-accent-300/60 transition-all duration-300 cursor-pointer flex flex-col items-center text-center"
            >
              <div
                className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl mb-3 transition-colors duration-300 ${
                  item.color === 'accent'
                    ? 'bg-accent-100 group-hover:bg-accent-200'
                    : 'bg-primary-100 group-hover:bg-primary-200'
                }`}
              >
                <i className={`${item.icon} text-lg md:text-xl ${item.color === 'accent' ? 'text-accent-600' : 'text-primary-600'}`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2 hidden sm:block">{item.desc}</p>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}